import { CloudCommand } from "../types.js";

export const isLinkedinConnectNoteRestricted: CloudCommand = {
    action: "GLOBAL/IS_LINKEDIN_CONNECT_NOTE_RESTRICTED",
    commandName: "linkedin.user.isLinkedinConnectNoteRestricted",
    buildPayload: ({ skipCache }) => ({ skipCache }),
    transformResponse: (data) => {
        const result = data as { status: boolean; parsed?: boolean };
        return result.status === false ? false : result.parsed;
    },
};
